import Select from 'react-select';
import { useState, useEffect } from 'react';
const cx = require('classnames');

const SelectContainer = (props) => {
    
    const options = props.options || [];
    const [value, setValue] = useState(null);
    const onChange = props.onChange || (() => {});
    const errormsg = props.error || false;
    const label = props.label || '';
    const id = props.id || 'id_select_'+label.replace(/[^A-Za-z0-9-_]/g, '');

    useEffect(() => {
        const initialValue = options.find(opt => opt.value == props.value) || null; // Using == for type coercion
        setValue(initialValue);
    }, [props.value, options]);
  
    const handleChange = (selectedOptions) => {
        setValue(selectedOptions);
        if (Array.isArray(selectedOptions)) {
            onChange(props.id, selectedOptions.map(option => option.value));
        } else {
            onChange(props.id, selectedOptions?.value);
        }
    };

    return (
         <div className={ cx('form-group', { 'has-error': !!errormsg }) }>
            <label className={ cx(props.className) } htmlFor={ id }>{ label }</label>
            <div className={ cx('col-sm-10 input-group') }>
        <Select
            options={options}
            value={value}
            onChange={handleChange}
            isMulti={props.isMulti}
                styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({ ...provided, zIndex: 3 })
                        }}
        />
        </div>
        </div>
    );
};

export default SelectContainer;